// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tetherContainer":"Dropdown__tetherContainer___2BSla"};
    if(module.hot) {
      // 1778083495045
      var cssReload = require("/home/ubuntu/ideapad-design-changes/ideapad/node_modules/extract-css-chunks-webpack-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hot":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  